import { postMAIAA030 } from '../../../../services/Api';

const MAIAA030 = ({ handleClosePopup }) => {
    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const formData = new FormData();
            formData.append('file', file);

            postMAIAA030(formData)
                .then(() => {
                    console.log('Uploaded');
                })
                .catch((error) => console.log(error));
        }
    };

    return (
        <div id="content">
            <div className="container">
                <div id="popup" data-popup="issuance-of-bulk-tickets">
                    <div className="overlay" />
                    <div className="popup-content">
                        <div className="popup-close" onClick={handleClosePopup} />
                        <div className="popup-title">일괄 이용권 발급</div>
                        <div className="form-group-bulk-tickets">
                            {/* <div className="popup-button btn-download-excel">샘플파일 다운로드</div> */}
                            <div
                                className="popup-button btn-download-excel"
                                onClick={() => {
                                    const link = document.createElement('a');
                                    link.href = '/upload/emticket_gift_sample.xls';
                                    link.download = 'emticket_gift_sample.xls';
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                }}
                            >
                                샘플파일 다운로드
                            </div>

                            <table className="table-gray">
                                <tbody>
                                    <tr>
                                        <td className="col-1">엑셀파일 선택</td>
                                        <td>
                                            <div className="flex">
                                                <input
                                                    placeholder="파일 선택"
                                                    id="select-file"
                                                    type="file"
                                                    accept=".xlsx, .xls"
                                                    onChange={handleFileChange}
                                                />
                                                {/* <button className="popup-button" htmlFor="select-file">
                                                    파일 첨부
                                                </button> */}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="h-129">
                                        <td className="col-1">등록 결과</td>
                                        <td>
                                            <table
                                                className="table-child active"
                                                style={{ borderTop: 'none', borderBottom: 'none' }}
                                            >
                                                <tbody>
                                                    <tr>
                                                        <td>비타민아이디</td>
                                                        <td>상품코드</td>
                                                        <td>구매일자</td>
                                                        <td>사은품구분</td>
                                                        <td>코멘트</td>
                                                        <td>등록순번</td>
                                                        <td>등록결과</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ehcheng2</td>
                                                        <td>001</td>
                                                        <td>2019-07-15</td>
                                                        <td>사은품</td>
                                                        <td />
                                                        <td>128430</td>
                                                        <td>등록완료</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ehcheng2</td>
                                                        <td>002</td>
                                                        <td>2019-07-15</td>
                                                        <td>멤버십 가입사은품</td>
                                                        <td />
                                                        <td>128431</td>
                                                        <td>등록완료</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="title-writing-guide">작성 가이드 보기</div>
                            <div className="how-to-create-file">
                                <div className="title-create-file">
                                    <p>[ 파일 작성방법 ]</p>
                                </div>
                                <ul className="list-create-file-guide">
                                    <p>1. 등록파일형식 :</p>
                                    <li>1) 첨부된 엑셀 파일 참고 (샘플파일)</li>
                                </ul>
                                <ul className="list-create-file-guide">
                                    <p>2. 칼럼명 순서 :</p>
                                    <li>1) 머리글-&gt; 비타민아이디, 상품코드, 구매일자, 사은품구분, 코멘트</li>
                                    <li className="redText">
                                        2) 상품코드 : 엑셀파일에서 텍스트 형식으로 001, 002 와 같이 등록되어야 함
                                    </li>
                                    <li>3) 구매일자 : 2019-07-01 과 같이 - 으로 구분</li>
                                </ul>
                                <ul className="list-create-file-guide">
                                    <p>3. 시트개수제한 :</p>
                                    <li>1) Sheet1 하나만 있어야 함</li>
                                </ul>
                                <ul className="list-create-file-guide">
                                    <p>4. 행개수제한 :</p>
                                    <li>1) 머리클 제외 199행까지만 가능 (머리글 포함 200행, 머리글 반드시 포함)</li>
                                </ul>
                                <ul className="list-create-file-guide">
                                    <p>5. 주의사항 :</p>
                                    <li>
                                        1) 신청자 일괄등록이 완료된 후에는 일괄삭제는 할 수 없으며, 정보수정 및 삭제시
                                        개별 상세정보를 이용해야 함
                                    </li>
                                </ul>
                                <ul className="list-create-file-guide">
                                    <p>6. 등록코드참조 :</p>
                                </ul>
                                <table className="table-create-file-guide">
                                    <tbody>
                                        <tr>
                                            <th colSpan={7} className="col-main">
                                                상품코드
                                            </th>
                                            <th colSpan={3}>사은품구분</th>
                                        </tr>
                                        <tr>
                                            {/* Cột nhỏ bên trong Cột Chính 1 */}
                                            <td colSpan={5} className="col-small-70">
                                                명칭
                                            </td>
                                            <td colSpan={2} className="col-small-30">
                                                코드
                                            </td>
                                            {/* Cột nhỏ bên trong Cột Chính 2 */}
                                            <td colSpan={2} className="col-small-70">
                                                명칭
                                            </td>
                                            <td colSpan={1} className="col-small-30">
                                                코드
                                            </td>
                                        </tr>
                                        <tr>
                                            {/* Dữ liệu trong các cột nhỏ */}
                                            <td colSpan={5}>
                                                <p>덴탈잡채용광고</p>
                                                <p>덴탈잡그랜드배너 (채용광고포함)</p>
                                                <p>덴탈잡프리미엄배너(채용광고포함)</p>
                                                <p>덴탈잡핫리쿠르트(채용광고포함)</p>
                                                <p>하이라이트강조</p>
                                                <p>하이라이트강조2</p>
                                                <p>컬러강조</p>
                                                <p>컬러강조2</p>
                                                <p>아이콘강조(이용권)</p>
                                                <p>아이콘강조2(이용권)</p>
                                                <p>핫리쿠르트배너고정옵션</p>
                                                <p>고정옵션</p>
                                                <p>그랜드배너고정옵션</p>
                                                <p>프리미엄배너고정옵션</p>
                                            </td>
                                            <td colSpan={2}>
                                                <p>001</p>
                                                <p>002</p>
                                                <p>003</p>
                                                <p>008</p>
                                                <p>1000</p>
                                                <p>1500</p>
                                                <p>2000</p>
                                                <p>2500</p>
                                                <p>3000</p>
                                                <p>3500</p>
                                                <p>4000</p>
                                                <p>5000</p>
                                                <p>6000</p>
                                                <p>7000</p>
                                            </td>
                                            <td colSpan={2}>
                                                <p>없음</p>
                                                <p>사은품 </p>
                                                <p>멤버십증정</p>
                                            </td>
                                            <td colSpan={1}>
                                                <p>공란</p>
                                                <p>Y1</p>
                                                <p>Z1</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <button className="popup-button">이용권 발급</button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAIAA030;
